import styled, { createGlobalStyle } from "styled-components";

export const PageTitle = styled.h2`
  font-size: 21px;
  font-weight: 700;
  color: #313131;
  margin-bottom: 16px;
  font-family: 'Caixa Std';
  line-height: 2.5rem;

  @media (min-width: 1024px) {
    font-size: 28px;
  }
`;

export const MobileContainerPadding = createGlobalStyle`
  @media (max-width: 768px) {
    .row.px-0.mx-0 > .container {
      padding: 80px 16px;
    }
  }
`;
